import React from "react";
import { graphql, useFragment } from "react-relay";
import { Divider } from "src/components/ui/divider";

import { JobRunDetails_jobRun$key } from "./__generated__/JobRunDetails_jobRun.graphql";
import { JobRunHeader } from "./JobRunHeader";
import { JobRunOutput } from "./JobRunOutput";

// Define the fragment that specifies what data this component needs
export const jobRunDetailsFragment = graphql`
  fragment JobRunDetails_jobRun on GraphQLJobRun {
    id
    name
    createdAt
    updatedAt
    status
    job {
      id
      name
      taskType
    }
    investigation {
      id
      summary
    }
    ...JobRunHeader_jobRun
    ...JobRunOutput_jobRun
  }
`;

export interface JobRunDetailsProps {
  /** The job run data */
  jobRun: JobRunDetails_jobRun$key;
  /** Optional content to display on the right side of the header */
  rightContent?: React.ReactNode;
  /** Context for display (affects label for created date) */
  context?: "alert" | "digest";
}

function JobRunDetails({
  jobRun,
  rightContent,
  context,
}: JobRunDetailsProps) {
  // Use fragment to extract data
  const data = useFragment(jobRunDetailsFragment, jobRun);

  return (
    <div>
      {/* Job Run Header */}
      <JobRunHeader
        jobRun={data}
        rightContent={rightContent}
        context={context}
      />

      <Divider />

      {/* Job Run Output */}
      <JobRunOutput
        jobRun={data}
        taskType={data.job?.taskType}
      />
    </div>
  );
}

export default JobRunDetails;